import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { formatDate } from '@angular/common';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpiposition, kpi, bmincoming, surveyQuestionMaster, bmsurveyQuestion, bmincomingattendees, bmInOutGoingStatusHistroy, year } from '../../../models/slakpi';
import { division } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';
import { uniqBy } from 'lodash';
import { SLAKPIApiService } from '../../../services/slakpi.service';
@Component({
  selector: 'app-bench-mark-incoming',
  templateUrl: './bench-mark-incoming.component.html',
  styleUrls: ['./bench-mark-incoming.component.css']
})
export class BenchMarkIncomingComponent implements OnInit {
  objBMIncomingAttendees = new bmincomingattendees();
  objBM: any = new bmincoming();
  columnAtdDefinitions: Column[];
  atdGrid: AngularGridInstance;
  datasetAtd: any;
  selTab: boolean = true;
  selTab2: boolean = false;
  selTab3: boolean = false;
  submitted: boolean = false;
  surveyQuestionUno: number = 0;
  isValidEmail: boolean = false;
  invalid: boolean = false;
  public visitor_data: any;
  public organizationType_data: any;
  public division_data: any;
  public letterStatus_data: any;
  public MDCEOResponse_data: any;
  public LogisticStatus_data: any;
  public VisitStatus_data: any;
  public Delegated_data: any;
  public benchMarkYear_data: any;
  public currentHalf_data: any;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public mindate: any;
  public PopoverModule;
  modalRef: BsModalRef;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('addAttendeeTemplate', { static: false }) addAttendeeTemplate: TemplateRef<any>;
  @ViewChild('statusUpdateTemplate', { static: false }) statusUpdateTemplate: TemplateRef<any>;
  @ViewChild('surveyUpdateTemplate', { static: false }) surveyUpdateTemplate: TemplateRef<any>;
  @ViewChild('statusUpdateHistroyTemplate', { static: false }) statusUpdateHistroyTemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  angularGrid: AngularGridInstance;
  public BMIncoming_data: any;
  public uploadedFiles: Array<File> = [];
  columnDefinitions_Approve: Column[];
  gridOptions_Approve: GridOption;
  dataset_Approve: any;
  angularGrid_Approve: AngularGridInstance;
  public BMIncoming_data_Approve: any;

  yearfilter: any;
  divisionUnofilter: any;
  halffilter: any;
  positionfilter: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  isStart: boolean = true;
  public filterDataCollectionCount: number = 0;
  public filterOverdueCount: number = 0;
  public filterCompletedCount: number = 0;
  public filterApprovalCount: number = 0;

  public filterAll_classactive: string = '';
  public filterDataCollection_classactive: string = 'active';
  public filterOverdue_classactive: string = '';
  public filterCompleted_classactive: string = '';
  public filterApproval_classactive: string = '';
  public tranBenchMarkKPIHistory_data: any;

  objTranBenchmarkKPI: any = new tranbenchmarkkpi();
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean;
  statusUno: number = 1;
  position_data: any;

  selectedItem: any;


  surveyQuestionDDList: any = [];
  surveyquestionbtn = 'Add';
  multipleSurveyQuestion: any = [];
  bmIncomingID: any;
  public selectedEditItemIndex: number;
  btnText: string = 'Add';


  searchText: string;
  dataSearch: any[];
  editID: any;
  /* statusDDList = [{ value: 0, text: 'Draft' }, { value: 3, text: 'Approved' }, { value: 4, text: 'On Hold' }, { value: 5, text: 'Rejected' }, { value: 6, text: 'Conducted' }];*/

  statusDDList = [{ value: 1, text: 'Draft' }, { value: 2, text: 'Approved' }, { value: 3, text: 'Rejected BY MD' }];

  dataHistroy: any;
  bmRequestStatusHistroyDataSet: any[];
  histroyColumnDefinitions: any;

  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  yearData: any = [];
  yearUno: number = 0;
  constructor(public restApi: BMApiService, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService, public restSLAKPIApi: SLAKPIApiService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  //Method used To Validate User Permission
  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    //if (!this.isAdmin  ) {
    //  let userPermissionData = this.userService.getUserRights("Incoming Benchmarking Request");
    //  if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
    //    if (userPermissionData[0].showPage == 1 && !this.isBMChampion) {

    //    }
    //    else {
    //      this.router.navigateByUrl('/access-denied');
    //    }
    //  }
    //}
    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Add incoming BM request");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    //  

    this.gridOptions = {


      //autoResize: {

      //  containerId: 'musherat-grid',

      //  sidePadding: 10

      //},

      //editable: true,

      //enableCellNavigation: false,
      //enableColumnReorder: false,

      //enableColumnPicker: true,

      //enableExcelCopyBuffer: true,

      //enableFiltering: true,

      //enablePagination: true,

      //autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [20, 50, 100, 200, 500, 1000, 1500, 2000],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid-incoming',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: false,
      //frozenColumn: 0


    };




    this.LoadBMIncoming();

    //this.loadBenckMarkKPIInboxCount();
    this.loadYear();
    this.getVisitorFrom();
    this.getOrganizationType();
    this.getDivisions();
    this.getLetterStatus();
    this.getMDCEOResponse();
    this.getLogisticStatus();
    this.getVisitStatus();
    this.getISDelegated();
    this.getSurveyQuestionDD();
    this.setMindate();
  }
  angularAtdGridReady(angularGrid: AngularGridInstance) {
    this.atdGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }


  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  angularGridReady_Approve(angularGrid: AngularGridInstance) {
    this.angularGrid_Approve = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restSLAKPIApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  getAttendee(id) {
    let inpValue = new bmincomingattendees();
    inpValue.visitTrackUno = id;
    inpValue.userUno = this.login_UserID;

    this.restApi.getBMIncomingAtd(inpValue)
      .subscribe(data => {
        this.datasetAtd = data;
        this.setAtdDefn();
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  setAtdDefn() {
    this.columnAtdDefinitions = [
      { id: 'organization', name: 'Organization', field: 'organization', sortable: true },
      { id: 'firstName', name: 'First Name', field: 'firstName', sortable: true },
      { id: 'lastName', name: 'Last Name', field: 'lastName', sortable: true },
      { id: 'email', name: 'Email', field: 'email', sortable: true },
      { id: 'mobileNumber', name: 'Mobile Number', field: 'mobileNumber', sortable: true },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [

            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-lg fa-edit', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                debugger;
                this.pageAction = 'edit';
                let rdata: any = args.dataContext;
                this.objBMIncomingAttendees = new bmincomingattendees();
                this.objBMIncomingAttendees = rdata;
                this.btnText = 'Update';
              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
            {
              command: 'atd-row', titleKey: 'atd_ROW', positionOrder: 64, title: 'Delete',
              iconCssClass: 'fa fa-lg fa-trash', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'view';
                let rdata: any = args.dataContext;
                this.objBMIncomingAttendees = new bmincomingattendees();
                this.objBMIncomingAttendees = rdata;

                Swal.fire({
                  text: 'Please confirm to delete',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.objBM.isActive = 0;
                    this.delAttendees();
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                })

              },
              //  // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }
    ];
  }
  cancelAttendee(val) {
    this.objBMIncomingAttendees = new bmincomingattendees();
    this.btnText = 'Add';
    val.submitted = false;
    this.modalRef.hide();
  }
  validateEmail(email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }
  addAttendees(val) {
    

    if (!val.form.valid) {
      //Swal.fire('Error', 'Please enter required field.', 'error');
      this.toaster.show('warning', 'Warning', 'Please enter the required fields.');
      return;
    }

    if (this.objBMIncomingAttendees.email != '') {
      if (this.validateEmail(this.objBMIncomingAttendees.email)) {
        this.isValidEmail = true;

      }
      else {
        this.isValidEmail = false;
        this.toaster.show('warning', 'Warning', 'Enter valid email.');
        return false;
      }
    }

    let checkDuplicateItem = this.datasetAtd.filter((items: any) => items.email == this.objBMIncomingAttendees.email);

    if (checkDuplicateItem.length > 0 && this.btnText == "Add") {
      this.toaster.show('warning', 'Warning', 'Duplicate attendee not allowed.');
      return false;
    }

    this.objBMIncomingAttendees.visitTrackUno = this.objBM.id;
    this.objBMIncomingAttendees.condition = (this.btnText == "Add") ? 0 : 8;
    this.objBMIncomingAttendees.userUno = this.login_UserID;
    this.restApi.addEditBMIncomingAttendees(this.objBMIncomingAttendees)
      .subscribe(data => {
        //Swal.fire({
        //  type: 'success',
        //  title: 'Attendee is saved.',
        //  showConfirmButton: false,
        //  timer: 1500
        //})
        this.toaster.show('success', 'Success', (this.btnText == "Add") ? 'Attendee is saved.' : 'Attendee is updated.');
        this.getAttendee(this.objBMIncomingAttendees.visitTrackUno);
        this.objBMIncomingAttendees = new bmincomingattendees();
        val.submitted = false;
        this.btnText = 'Add';

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }
  delAttendees() {
    
    this.objBMIncomingAttendees.condition = 5;
    this.objBMIncomingAttendees.userUno = this.login_UserID;
    this.restApi.addEditBMIncomingAttendees(this.objBMIncomingAttendees)
      .subscribe(data => {
        //Swal.fire({
        //  type: 'success',
        //  title: 'Attendee is deleted.',
        //  showConfirmButton: false,
        //  timer: 1500
        //})
        this.toaster.show('success', 'Success', 'Attendee is deleted.');
        this.getAttendee(this.objBMIncomingAttendees.visitTrackUno);
        this.objBMIncomingAttendees = new bmincomingattendees();


      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }
  getVisitorFrom() {
    

    this.visitor_data = [
      { text: 'Local', value: 1 },
      { text: 'Regional', value: 2 },
      { text: 'International', value: 3 },

    ];
  }
  getOrganizationType() {
    

    this.organizationType_data = [
      { text: 'Government', value: 1 },
      { text: 'Semi Government', value: 2 },
      { text: 'Private', value: 3 },
      { text: 'Not Applicable', value: 4 },
    ];
  }
  getLetterStatus() {
    //this.letterStatus_data = [
    //  { text: 'Pending', value: 1 },
    //  { text: 'Completed', value: 2 }
    //];

    this.letterStatus_data = [
      { text: 'In Progress ', value: 1 },
      { text: 'Approved', value: 2 },
      { text: 'Rejected', value: 3 },
      { text: 'On Hold', value: 4 }
    ];
  }

  getMDCEOResponse() {
    this.MDCEOResponse_data = [
      { text: 'Approve', value: 1 },
      { text: 'Reject', value: 2 }
    ];
  }

  getLogisticStatus() {
    this.LogisticStatus_data = [
      { text: 'In Progress', value: 1 },
      { text: 'Pending', value: 2 },
      { text: 'Completed', value: 3 }
    ];
  }
  getVisitStatus() {
    //this.VisitStatus_data = [
    //  { text: 'Conducted', value: 1 },
    //  { text: 'On Hold', value: 2 },
    //  { text: 'No Response', value: 3 },
    //  { text: 'On-going', value: 4 }
    //];

    this.VisitStatus_data = [
      { text: 'In Progress', value: 1 },
      { text: 'Scheduled', value: 7 },
      { text: 'On Hold', value: 2 },
      { text: 'No Response', value: 6 },
      { text: 'Conducted', value: 3 }
      //{ text: 'Conducted (virtual)', value: 4 },
      //{ text: 'Cancelled', value: 5 },
     
      


    ];
  }
  getISDelegated() {
    this.Delegated_data = [
      { text: 'Yes', value: 1 },
      { text: 'No', value: 2 }
    ];
  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  searchKPIRelease() {
    
    let temp = this;
    this.spinner.show();
    if (!this.isStart) {
      setTimeout(function () { temp.LoadBMIncoming(); }, 1000)

    }

  }

  openModalWithClass(addtemplate: TemplateRef<any>) {
    

    this.pageAction = "add";
    this.objBM = new bmincoming();
    this.selTab = true;
    this.selTab2 = false;
    this.selTab3 = false;
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  LoadBMIncoming() {
    

    let inpValue = new bmincoming();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.yearUno = this.yearUno ? this.yearUno : 0;
    this.restApi.getBMIncoming(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = data;
        const mockDataset = [];
        this.dataset = [];
        if (rtn_data != null && rtn_data.length > 0) {

          //uniqBy(data, 'kpiUno');

          for (let i = 0; i < rtn_data.length; i++) {



            mockDataset[i] = {
              id: rtn_data[i].visitTrackUno,
              requestFrom: rtn_data[i].requestFrom,
              visitorFrom: rtn_data[i].visitorFrom,
              // companyName: rtn_data[i].companyName,
              organizationType: rtn_data[i].organizationType,
              // subject: rtn_data[i].subject,
              requestedTopics: rtn_data[i].requestedTopics,
              receivedOn: rtn_data[i].receivedOn,
              locationorVenue: rtn_data[i].locationorVenue,
              bmChampionProposedDateOn: rtn_data[i].bmChampionProposedDateOn,
              concernedDivisionorTeam: rtn_data[i].concernedDivisionorTeam,
              division: rtn_data[i].division,
              conductedVisitorRemoteMeetingOn: rtn_data[i].conductedVisitorRemoteMeetingOn,
              delegatesConfirmedOn: rtn_data[i].delegatesConfirmedOn,
              delegatesFilledOn: rtn_data[i].delegatesFilledOn,
              forwardedtoConcerenedDivisionOn: rtn_data[i].forwardedtoConcerenedDivisionOn,
              letterStatus: rtn_data[i].letterStatus,
              logisticsStatus: rtn_data[i].logisticsStatus,
              mdceoResponse: (rtn_data[i].mdceoResponse == '') ? 'Draft' : rtn_data[i].mdceoResponse,
              officialReplySentOn: rtn_data[i].officialReplySentOn,
              replySentTo: rtn_data[i].replySentTo,
              submittedInSmartDocumentOn: rtn_data[i].submittedInSmartDocumentOn,
              letterReferenceNo: rtn_data[i].letterReferenceNo,
              isDelegatesFilled: rtn_data[i].isDelegatesFilled,
              visitRemoteMeetingStatus: rtn_data[i].visitRemoteMeetingStatus,
              fconductedVisitedOn: (formatDate(rtn_data[i].conductedVisitorRemoteMeetingOn, 'yyyy', 'en-US') != '9999') ? formatDate(rtn_data[i].conductedVisitorRemoteMeetingOn, 'dd-MM-yyy', 'en-US') : '-',
              freceivedOn: formatDate(rtn_data[i].receivedOn, 'dd-MM-yyy', 'en-US'),
              //Comment on 01-05-2024 based on business request
              //year: (formatDate(rtn_data[i].receivedOn, 'yyyy', 'en-US') != '9999') ? formatDate(rtn_data[i].receivedOn, 'yyyy', 'en-US') : '',
              year: (formatDate(rtn_data[i].conductedVisitorRemoteMeetingOn, 'yyyy', 'en-US') != '9999') ? formatDate(rtn_data[i].conductedVisitorRemoteMeetingOn, 'yyyy', 'en-US') : '-',
              //quarter: formatDate(rtn_data[i].receivedOn, 'qq', 'en-US'),
              satisfactionRate: (rtn_data[i].satisfactionRate != '') ? rtn_data[i].satisfactionRate : '-',
              quarter: (formatDate(rtn_data[i].conductedVisitorRemoteMeetingOn, 'yyyy', 'en-US') != '9999') ? rtn_data[i].quarter : '-',
              fullFillDay: (formatDate(rtn_data[i].conductedVisitorRemoteMeetingOn, 'yyyy', 'en-US') != '9999') ? rtn_data[i].fullFillDay : '-'
            };
          }
          this.dataset = mockDataset;
          this.dataSearch = mockDataset;
          if (mockDataset.length > 0) {
            this.setColnDefn();
          }
          this.BMIncoming_data = rtn_data;

          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
        else {
          this.dataset = [];
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  dateFormat(value) {
    if (value)
      return formatDate(value, 'yyyy-MM-dd', 'en-US');
    else
      return null;
  }

  changeYear() {
    
    let temp = this;
    this.spinner.show();
    if (!this.isStart) {
      setTimeout(function () { temp.LoadBMIncoming(); }, 1000)

    }
  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.requestFrom && a.requestFrom.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.visitorFrom && a.visitorFrom.toLowerCase().includes(this.searchText.toLowerCase()))
        //|| (a.companyName && a.companyName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.organizationType && a.organizationType.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.freceivedOn && a.freceivedOn.toLowerCase().includes(this.searchText.toLowerCase()))
        //|| (a.subject && a.subject.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.requestedTopics && a.requestedTopics.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.mdceoResponse && a.mdceoResponse.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }

  setColnDefn() {
    let temp = this;
    

    this.columnDefinitions = [
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue',
        minWidth: 50,
        //width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,

        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [

            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',

              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-edit', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                debugger;
                let rdata: any = args.dataContext;
                this.selectedItem = rdata;
                this.editID = rdata.id;
                this.objBM = this.BMIncoming_data.filter((items: any) => items.visitTrackUno == rdata.id)[0];
                //this.objBM = rdata;
                //this.objBM.receivedOn = new Date('01/01/2021');receivedOn
                this.objBM.concernedDivisionorTeam = (this.objBM.concernedDivisionorTeam) ? this.utilityService.CommaSeperatorToArrayParseInt(this.objBM.concernedDivisionorTeam.toString()) : [];

                this.objBM.receivedOn = (this.objBM.receivedOn != "") ? formatDate(this.objBM.receivedOn, 'yyyy-MM-dd', 'en-US') : this.objBM.receivedOn;
                this.objBM.receivedOn = (this.objBM.receivedOn == "9999-01-01") ? '' : this.objBM.receivedOn;

                this.objBM.bmChampionProposedDateOn = (this.objBM.bmChampionProposedDateOn != "") ? formatDate(this.objBM.bmChampionProposedDateOn, 'yyyy-MM-dd', 'en-US') : this.objBM.bmChampionProposedDateOn;
                this.objBM.bmChampionProposedDateOn = (this.objBM.bmChampionProposedDateOn == "9999-01-01") ? '' : this.objBM.bmChampionProposedDateOn;

                this.objBM.delegatesConfirmedOn = (this.objBM.delegatesConfirmedOn != "") ? formatDate(this.objBM.delegatesConfirmedOn, 'yyyy-MM-dd', 'en-US') : this.objBM.delegatesConfirmedOn;
                this.objBM.delegatesConfirmedOn = (this.objBM.delegatesConfirmedOn == "9999-01-01") ? '' : this.objBM.delegatesConfirmedOn;

                this.objBM.mdceoResponse = rdata.mdceoResponse;
                this.objBM.delegatesFilledOn = rdata.delegatesFilledOn;



                this.objBM.submittedInSmartDocumentOn = (this.objBM.submittedInSmartDocumentOn != "") ? formatDate(this.objBM.submittedInSmartDocumentOn, 'yyyy-MM-dd', 'en-US') : this.objBM.submittedInSmartDocumentOn;
                this.objBM.submittedInSmartDocumentOn = (this.objBM.submittedInSmartDocumentOn == "9999-01-01") ? '' : this.objBM.submittedInSmartDocumentOn;


                this.objBM.officialReplySentOn = (this.objBM.officialReplySentOn != "") ? formatDate(this.objBM.officialReplySentOn, 'yyyy-MM-dd', 'en-US') : this.objBM.officialReplySentOn;
                this.objBM.officialReplySentOn = (this.objBM.officialReplySentOn == "9999-01-01") ? '' : this.objBM.officialReplySentOn;
                

                this.objBM.forwardedtoConcerenedDivisionOn = (this.objBM.forwardedtoConcerenedDivisionOn != "") ? formatDate(this.objBM.forwardedtoConcerenedDivisionOn, 'yyyy-MM-dd', 'en-US') : this.objBM.forwardedtoConcerenedDivisionOn;
                this.objBM.forwardedtoConcerenedDivisionOn = (this.objBM.forwardedtoConcerenedDivisionOn == "9999-01-01") ? '' : this.objBM.forwardedtoConcerenedDivisionOn;


                this.objBM.conductedVisitorRemoteMeetingOn = (this.objBM.conductedVisitorRemoteMeetingOn != "") ? formatDate(this.objBM.conductedVisitorRemoteMeetingOn, 'yyyy-MM-dd', 'en-US') : this.objBM.conductedVisitorRemoteMeetingOn;
                this.objBM.conductedVisitorRemoteMeetingOn = (this.objBM.conductedVisitorRemoteMeetingOn == "9999-01-01") ? '' : this.objBM.conductedVisitorRemoteMeetingOn;
                

                this.bmIncomingID = rdata.id;
                this.multipleSurveyQuestion = [];
                this.getBMSurveyQuestion(this.bmIncomingID);

                //this.getViewHistory(rdata.id);
                //this.router.navigateByUrl('/benchmarkkpiview/' + rdata.id);

                this.surveyquestionbtn = 'Add';
                this.modalRef = this.modalService.show(
                  this.addtemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );

              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },

            {
              command: 'atd-row', titleKey: 'atd_ROW', positionOrder: 66, title: 'Attendees',

              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-user-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'view';
                let rdata: any = args.dataContext;

                this.objBM = rdata;
                this.getAttendee(rdata.id);

                this.modalRef = this.modalService.show(
                  this.addAttendeeTemplate,
                  Object.assign({}, {
                    class: 'gray modal-lg',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );

              },
              //  // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 67 },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Update Status',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-refresh', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.objBM = rdata;
                this.multipleSurveyQuestion = [];
                this.getBMSurveyQuestion(this.editID);
                this.objBM.mdceoResponse = rdata.mdceoResponse;
                this.modalRef = this.modalService.show(
                  this.statusUpdateTemplate,
                  Object.assign({}, { class: 'gray modal-medium' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Update Survey Result',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMAdmin || this.isAdmin || this.isBMTeam || this.isBMChampion)
                  return true;
                else
                  return false;
              },
              iconCssClass: 'fa fa-edit', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.objBM = rdata;


                this.modalRef = this.modalService.show(
                  this.surveyUpdateTemplate,
                  Object.assign({}, { class: 'gray modal-medium' })
                );

              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Status History',
              iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'edit';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.loadBMIncomingStatusHistroy();
                this.objBM.comments = '';
                this.modalRef = this.modalService.show(
                  this.statusUpdateHistroyTemplate,
                  Object.assign({}, { class: 'gray modal-lg' })
                );
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 71 },
            {
              command: 'atd-row', titleKey: 'atd_ROW', positionOrder: 68, title: 'Delete',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if (this.isBMVisitor)
                  return false;
                else return true;
              },
              iconCssClass: 'fa fa-lg fa-trash', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.pageAction = 'view';
                let rdata: any = args.dataContext;


                Swal.fire({
                  text: 'Please confirm to delete',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';

                    this.DeleteBMIncoming(rdata);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                })

              },
            }
          ],
        }
      },

      {
        id: 'requestFrom', name: 'Request From', field: 'requestFrom', sortable: true,
        minWidth: 250,
        //width: 200,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data1) => {
          let per = data1.requestFrom;
          return '<div title="' + per + '">' + per + '</div>'
          // return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'requestFrom', 'requestFrom'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'organizationType', name: 'Organization Type', field: 'organizationType', sortable: true,
        minWidth: 200,
        //width: 200,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data1) => {
          let per = data1.organizationType;
          return '<div title="' + per + '">' + per + '</div>'
          // return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'organizationType', 'organizationType'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'visitorFrom', name: 'Level', field: 'visitorFrom', sortable: true,
        minWidth: 100,
        //width: 100,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'visitorFrom', 'visitorFrom'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'year', name: 'Year', field: 'year', sortable: true,
        //minWidth: 70,
        width: 70,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'year', 'year'),
          model: Filters.multipleSelect,
        }
      },

      //{
      //  id: 'companyName', name: 'Company Name', field: 'companyName', sortable: true, width: 50,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'companyName', 'companyName'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      {
        id: 'freceivedOn', name: 'Received On', field: 'freceivedOn', sortable: true, minWidth: 100,
        //width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'freceivedOn', 'freceivedOn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'fconductedVisitedOn', name: 'Benchmarking Meeting Date', field: 'fconductedVisitedOn', sortable: true, minWidth: 200,
        //width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'fconductedVisitedOn', 'fconductedVisitedOn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'quarter', name: 'Quarter', field: 'quarter', sortable: true,
        minWidth: 70,
        //width: 70,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'quarter', 'quarter'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'subject', name: 'Subject', field: 'subject', sortable: true, width: 50,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'subject', 'subject'),
      //    model: Filters.multipleSelect,
      //  }
      //},

      {
        id: 'requestedTopics', name: 'Requested Topics', field: 'requestedTopics', sortable: true,
        minWidth: 200,
        //width: 130,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data1) => {
          let per = data1.requestedTopics;
          return '<div title="' + per + '">' + per + '</div>'
          // return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'requestedTopics', 'requestedTopics'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'division', name: 'Division', field: 'division', sortable: true,
        minWidth: 200,
        //width: 120,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data1) => {
          let per = data1.division;
          return '<div title="' + per + '">' + per + '</div>'
          // return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'division', 'division'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'mdceoResponse', name: 'Request Status', field: 'mdceoResponse', sortable: true,
        minWidth: 150,
        //width: 150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'mdceoResponse', 'mdceoResponse'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'visitRemoteMeetingStatus', name: 'BM Meeting Status', field: 'visitRemoteMeetingStatus', sortable: true,
        minWidth: 150,
        //width: 120,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'visitRemoteMeetingStatus', 'visitRemoteMeetingStatus'),
          model: Filters.multipleSelect,
        }
      },



      {
        id: 'satisfactionRate', name: 'Happiness Rate', field: 'satisfactionRate', sortable: true,
        minWidth: 120,
        //width: 120,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'satisfactionRate', 'satisfactionRate'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'fullFillDay', name: 'Fulfillment Day', field: 'fullFillDay', sortable: true,
        minWidth: 120,
        //width: 120,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'fullFillDay', 'fullFillDay'),
          model: Filters.multipleSelect,
        }
      }
      




    ]
  }
  onDbClicked(ev, args) {
    
    //    this.router.navigateByUrl('/benchmarkkpiview/' + rdata.id);
    return false;
  }



  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }



  onNext(val) {
    
    if (val) {
      this.selTab = false;
      this.selTab2 = true;
      this.selTab3 = false;
    }
    else {
      this.toaster.show('warning', 'Warning', 'Please enter all the required fields in General Information tab.');

      return false;
    }

  }

  onSecondNext(val) {
    
    if (val) {
      this.selTab = false;
      this.selTab2 = false;
      this.selTab3 = true;
    }
    else {
      this.toaster.show('warning', 'Warning', 'Please enter all the required fields in Accountability tab.');

      return false;
    }
    //if (val) {
    //  this.selTab = false;
    //}
    //else {
    //  Swal.fire('Error', 'Please enter the General Information.', 'error')
    //}

  }

  onChangeTab(selectedTab: any) {
    if (selectedTab == 'general') {
      this.selTab = true;
      this.selTab2 = false;
      this.selTab3 = false;

    }
    else if (selectedTab == 'accountability') {
      this.selTab = false;
      this.selTab2 = true;
      this.selTab3 = false;

    }
    else if (selectedTab == 'suervey') {
      this.selTab = false;
      this.selTab2 = false;
      this.selTab3 = true;

    }
    return false;
  }
  onSubmit(val1, val2) {
    
    //To Check file count && Check file size && Check file exe
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      for (var i = 0; i < this.uploadedFiles.length; i++) {
        let fileName = this.uploadedFiles[i].name.toLowerCase();
        let fileSize = this.uploadedFiles[i].size;
        
        //To check file exe
        if (!this.userService.checkImageValuranabity(fileName, fileSize)) {
          this.toaster.show('error', 'Error', 'General Information - Please select the correct image format.');
          return false;
        }

        //Check file size
        if (!this.userService.checkFileSize(fileSize)) {
          this.toaster.show('error', 'Error', 'General Information - A file size should not above 30MB.');
          return;
        }
      }

      //Check file count 
      if (this.uploadedFiles.length > 1) {
        this.toaster.show('warning', 'Warning', 'General Information - Upload one image.');
        return;
      }
    }
    //if (!val1 && !val2) {

    //  this.toaster.show('warning', 'Warning', 'Please enter the required information.');
    //  this.selTab = true;
    //  this.selTab2 = false;
    //  this.selTab3 = false;
    //  return;
    //}
    if (!val1) {

      this.toaster.show('warning', 'Warning', 'Please enter all the required fields in General Information tab.');
      this.selTab = true;
      this.selTab2 = false;
      this.selTab3 = false;
      return;
    }
    //else if (!val2) {

    //  this.toaster.show('warning', 'Warning', 'Please enter the Accountability Information.');
    //  this.selTab = false;
    //  this.selTab2 = true;
    //  this.selTab3 = false;
    //  return;

    //}
    //else if (this.multipleSurveyQuestion.length == 0) {

    //  this.toaster.show('warning', 'Warning', 'Please add survey group.');
    //  this.selTab = false;
    //  this.selTab2 = false;
    //  this.selTab3 = true;
    //  return;
    //}

    else {
      this.AddEditBMIncoming(this.objBM)
    }
  }


  DeleteBMIncoming(data1: any) {
    
    let objBM = new bmincoming();
    objBM = data1
    objBM.userUno = this.login_UserID;
    objBM.condition = 2;
    objBM.visitTrackUno = data1.id;
    objBM.id = data1.id;
    objBM.tenantUno = this.tenantUno;
    objBM.companyName = '';
    objBM.subject = '';
    this.restApi.addEditBMIncoming(objBM)
      .subscribe(data => {

        if (data == null && data == undefined && data == '') {
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          this.toaster.show('success', 'Success', 'Incoming BM request is Deleted.');

          setTimeout(() => { this.spinner.hide(); this.LoadBMIncoming(); }, 900);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }
  AddEditBMIncoming(data1: any) {
    
    if (this.uploadedFiles.length > 1) {
      this.toaster.show('warning', 'Warning', 'Upload one image');
      return;
    }

    //if (this.multipleSurveyQuestion == 0) {
    //  this.toaster.show('warning', 'Warning', 'Please select survey group');
    //  return false;
    //}
    
    let objBM = new bmincoming();
    objBM = data1
    objBM.concernedDivisionorTeam = (objBM.concernedDivisionorTeam) ? objBM.concernedDivisionorTeam.toString() : '';
    objBM.companyName = (objBM.companyName) ? objBM.companyName.toString() : '';
    objBM.bmChampionProposedDateOn = (objBM.bmChampionProposedDateOn) ? objBM.bmChampionProposedDateOn : new Date("9999-01-01");
    objBM.delegatesConfirmedOn = (objBM.delegatesConfirmedOn) ? objBM.delegatesConfirmedOn : new Date("9999-01-01");
    objBM.submittedInSmartDocumentOn = (objBM.submittedInSmartDocumentOn) ? objBM.submittedInSmartDocumentOn : new Date("9999-01-01");
    objBM.officialReplySentOn = (objBM.officialReplySentOn) ? objBM.officialReplySentOn : new Date("9999-01-01");
    objBM.delegatesFilledOn = (objBM.delegatesFilledOn) ? objBM.delegatesFilledOn : '';
    objBM.forwardedtoConcerenedDivisionOn = (objBM.forwardedtoConcerenedDivisionOn) ? objBM.forwardedtoConcerenedDivisionOn : new Date("9999-01-01");
    objBM.conductedVisitorRemoteMeetingOn = (objBM.conductedVisitorRemoteMeetingOn) ? objBM.conductedVisitorRemoteMeetingOn : new Date("9999-01-01");
    objBM.mdceoResponse = (this.editID != null && this.editID != undefined) ? this.objBM.mdceoResponse : 'Draft';
    objBM.userUno = this.login_UserID;
    objBM.condition = (this.pageAction == "add") ? 0 : 1;
    objBM.visitTrackUno = (this.pageAction == "add") ? 0 : this.bmIncomingID;
    objBM.id = (this.pageAction == "add") ? 0 : this.bmIncomingID;
    objBM.tenantUno = this.tenantUno;
    objBM.companyName = '';
    objBM.subject = '';
    this.restApi.addEditBMIncoming(objBM)
      .subscribe(data => {

        if (data == null && data == undefined && data == '') {
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'BM Incoming saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'Incoming BM request is saved.');
          this.bmIncomingID = (this.pageAction == 'edit') ? this.bmIncomingID : data;

          this.AddEditSurveyQuestionMultiEntry(this.bmIncomingID);
          this.saveFile();
          this.modalRef.hide();
          setTimeout(() => { this.spinner.hide(); this.LoadBMIncoming(); }, 900);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;
  }



  getSurveyQuestionDD() {
    let inpValue = new surveyQuestionMaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getSurveyQuestionMaster(inpValue)
      .subscribe(data => {

        this.surveyQuestionDDList = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }



  onAddSurveyQuestionEntry() {
    

    if (this.surveyQuestionUno == 0) {
      this.toaster.show('warning', 'Warning', 'Please select survey question');
      return false;
    }
    let surveyQuestionName = this.surveyQuestionDDList.filter(a => a.id == this.surveyQuestionUno)
    let id = (this.bmIncomingID != undefined) ? this.bmIncomingID : 0;
    if (this.surveyquestionbtn == 'Add') {
      let data1 = this.objBM;
      let objSurveyQestionEntry = {
        bmIUno: id,
        sqUno: this.surveyQuestionUno,
        surveyTitle: surveyQuestionName[0].surveyTitle
      }
      this.surveyQuestionUno = 0;
      
      //Check Duplicate Entry
      if (!this.CheckDuplicateItem(objSurveyQestionEntry)) {
        this.multipleSurveyQuestion.push(objSurveyQestionEntry);

      }
      else {
        // Swal.fire('Error', 'Duplicate values not allowed.', 'error'); return;
        this.toaster.show('error', 'Error', 'Duplicate values are not allowed.');
        return false;
      }

    }
    else {
      let data1 = this.objBM;
      let objSurveyQestionEntry = {
        bmIUno: this.bmIncomingID,
        sqUno: this.surveyQuestionUno,
        surveyTitle: surveyQuestionName[0].surveyTitle
      }
      this.surveyQuestionUno = 0;
      
      //Check Duplicate Entry
      this.multipleSurveyQuestion.splice(this.selectedEditItemIndex, 1);
      if (!this.CheckDuplicateItem(objSurveyQestionEntry)) {

        this.multipleSurveyQuestion.push(objSurveyQestionEntry);

        this.surveyquestionbtn = 'Add';
      }
      else {
        let objSurveyQestionEntry = {
          bmIUno: this.bmIncomingID,
          sqUno: this.surveyQuestionUno,
          surveyTitle: surveyQuestionName[0].surveyTitle
        }
        this.surveyQuestionUno = 0;
        this.multipleSurveyQuestion.push(objSurveyQestionEntry);

        // Swal.fire('Error', 'Duplicate values not allowed.', 'error'); return;
        this.toaster.show('error', 'Error', 'Duplicate values are not allowed.');
      }
      //this.objTranBenchmarkKPI = new tranbenchmarkkpi();
    }

    return false;
  }
  CheckDuplicateItem(obj: any) {
    if (this.multipleSurveyQuestion != null && this.multipleSurveyQuestion != undefined) {
      
      var rtnValue = false;
      let listItems = this.multipleSurveyQuestion;
      let enteredQuestionUno = obj.sqUno;
      listItems.forEach((item) => {
        let existQuestionUno = item.sqUno;
        if (enteredQuestionUno == existQuestionUno) {

          rtnValue = true;
        }

      });

      return rtnValue;
    }
  }
  onRemoveItem(idx) {
    
    this.multipleSurveyQuestion.splice(idx, 1);
    return false;
  }


  AddEditSurveyQuestionMultiEntry(id: any) {
    

    this.surveyquestionbtn = 'Add';
    let obj = new bmincoming();

    obj.userUno = this.login_UserID;


    //XML Value For KPIBenchMark Entry

    let entryItems = this.multipleSurveyQuestion;
    if (entryItems.length > 0) {
      obj.id = id;
      let strXmlValue = '<roots>';
      for (var i = 0; i < entryItems.length; i++) {

        strXmlValue += "<root>";
        strXmlValue += "<SQUno>" + entryItems[i].sqUno + "</SQUno>";
        strXmlValue += "<TenantUno>1</TenantUno>";
        strXmlValue += "</root>";
      }
      strXmlValue += '</roots>';
      
      obj.xmlData = strXmlValue;
    }
    else {
      obj.xmlData = "";
    }


    this.modalRef.hide();
    
    this.restApi.addEditBMIncomingSurveyQuestion(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          this.modalRef.hide();
          //Swal.fire({
          //  type: 'success',
          //  title: 'Survey Question Entry saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})

          setTimeout(() => {
            this.spinner.hide();
            this.multipleSurveyQuestion = [];
          }, 900);

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.multipleSurveyQuestion = [];
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  getBMSurveyQuestion(id: any) {
    let inpValue = new bmsurveyQuestion();
    inpValue.languageUno = 1033;
    inpValue.itemUno = id;
    inpValue.condition = 3;
    inpValue.userUno = this.login_UserID;
    this.restApi.getBMIncomingSurveyQuestion(inpValue)
      .subscribe(data => {
        if (data != '' && data != null && data != undefined) {
          this.multipleSurveyQuestion = data;
        }
        else {
          this.multipleSurveyQuestion = [];
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });

  }


  onStatusSubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter all the required fields.');
      return
    }

    else {
      this.updateBMStatus();
      this.modalRef.hide();
      setTimeout(() => {
        this.LoadBMIncoming();
      }, 500);
    }
  }
  updateBMStatus() {
    
    if (this.multipleSurveyQuestion.length == 0 && this.objBM.mdceoResponse == 'Approved') {
      this.modalRef.hide();
      this.toaster.show('warning', 'Warning', 'Not able to approved this request, because survey group is empty.');
      return false;
    }
    let obj = new bmincoming();
    obj.id = (this.editID) ? this.editID : 0;
    obj.comments = (this.objBM.comments) ? this.objBM.comments : '';
    obj.mdceoResponse = this.objBM.mdceoResponse;
    obj.requestFrom = this.objBM.requestFrom;
    obj.visitorFrom = this.objBM.visitorFrom;
    obj.companyName = '';// this.objBM.companyName;
    obj.organizationType = this.objBM.organizationType;
    obj.subject = '';// this.objBM.subject;
    obj.requestedTopics = this.objBM.requestedTopics;
    obj.userUno = this.login_UserID;
    obj.flag = 'bmincoming';
    this.restApi.updateBMIncomingStatus(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.toaster.show('success', 'Success', 'Status updated.');
          setTimeout(() => {
            this.objBM = new bmincoming();
            this.spinner.hide();
            this.LoadBMIncoming();
            this.modalRef.hide();
          }, 500);

        }
        else {

          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();

        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;

  }

  onSurveySubmit(val1) {
    
    if (!val1) {
      this.toaster.show('error', 'Error', 'Please enter all the required fields.');
      return
    }

    else {
      let obj = new bmincoming();
      obj.id = (this.editID) ? this.editID : 0;
      obj.mdceoResponse = this.objBM.satisfactionRate;
      obj.comments =  '';
      obj.userUno = this.login_UserID;
      obj.flag = 'bmincoming_surveyresult';
      this.restApi.updateBMIncomingStatus(obj)
        .subscribe(data => {
          
          if (data != null && data != undefined && data != '' && data != 'failure') {
            this.toaster.show('success', 'Success', 'Survey result updated.');
            setTimeout(() => {
              this.objBM = new bmincoming();
              this.spinner.hide();
              this.LoadBMIncoming();
              this.modalRef.hide();
            }, 500);

          }
          else {

            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });





    }
  }

  loadBMIncomingStatusHistroy() {
    this.spinner.show();
    let inpValue = new bmInOutGoingStatusHistroy();
    inpValue.flag = 'bmincoming';
    inpValue.id = (this.editID) ? this.editID : 0;
    inpValue.userUno = this.login_UserID;

    this.restApi.getBMInOutGoingStatus(inpValue)
      .subscribe(data => {
        

        this.dataHistroy = uniqBy(data, 'id');
        const mockDataset = [];
        for (let i = 0; i < this.dataHistroy.length; i++) {

          mockDataset[i] = {
            id: this.dataHistroy[i].id,
            reqNo: this.dataHistroy[i].reqNo,
            comments: this.dataHistroy[i].comments,
            status: this.dataHistroy[i].status,
            enteredBy: this.dataHistroy[i].enteredBy,
            enteredOn: this.dataHistroy[i].enteredOn,
            createdBy: this.dataHistroy[i].createdBy

          };
        }
        this.bmRequestStatusHistroyDataSet = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridBMIncomingStatusHistroyDefn();
        }
        else {
          this.setGridBMIncomingStatusHistroyDefn();
        }

        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  setGridBMIncomingStatusHistroyDefn() {
    let temp = this;
    this.histroyColumnDefinitions = [
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataHistroy, 'status', 'status'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'comments', name: 'Comments', field: 'comments', sortable: true, type: FieldType.string, filterable: false, width: 100,
        filter: {
          collection: this.uniqueArray(this.dataHistroy, 'comments', 'comments'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'enteredBy', name: 'Action By', field: 'enteredBy', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataHistroy, 'enteredBy', 'enteredBy'),
          model: Filters.multipleSelect,

        }
      },



      {
        id: 'enteredOn', name: 'Action Date', field: 'enteredOn', sortable: true, type: FieldType.string, filterable: false, width: 50,
        filter: {
          collection: this.uniqueArray(this.dataHistroy, 'enteredOn', 'enteredOn'),
          model: Filters.multipleSelect,

        }
      },


    ]


  }



  saveFile() {

    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      if (this.uploadedFiles.length > 5) {
        this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
        return false;
      }
      let formData = new FormData();
      let isFileReadyForUpload = false;
      for (var i = 0; i < this.uploadedFiles.length; i++) {
        let allowFile = false;
        let fileName = this.uploadedFiles[i].name.toLowerCase();
        let fileSize = this.uploadedFiles[i].size;
        //Check file size
        let allowFileSize = false;
        allowFileSize = this.userService.checkFileSize(fileSize);
        if (!allowFileSize) {
          this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
          return;
        }
        //To check filee size exe  
        allowFile = this.userService.checkFileValuranabity(fileName, fileSize);

        if (allowFile) {
          formData.append("file", this.uploadedFiles[i]);
          isFileReadyForUpload = true;
        }
      }
      if (isFileReadyForUpload) {
        formData.append("id", this.bmIncomingID);
        formData.append("flag", "BMIncoming");
        formData.append("userUno", this.login_UserID.toString());
        this.restApi.fileManagerFileUpload(formData)
          .subscribe(data => {
            
            if (data == null || data == undefined || data == '') {

            }
            else {
              //  this.toaster.show('success', 'Success', 'File uploaded.');
              //this.RefreshDirectory();
              //this.selectedRecord = new fileManager();
            }
            this.uploadedFiles = [];
            this.spinner.hide();
          },
            (error) => {
              this.spinner.hide();
            }
          ).add(() => {
            this.spinner.hide();
          });
      }
    }
    //else {
    //  this.toaster.show('error', 'Error', 'Please select the file');
    //}
  }

  setMindate() {
    let dtToday = new Date();

    let month: any = dtToday.getMonth() + 1;
    let day: any = dtToday.getDate();
    let year: any = dtToday.getFullYear();
    if (month < 10)
      month = '0' + month.toString();
    if (day < 10)
      day = '0' + day.toString();

    let maxDate: any = year + '-' + month + '-' + day;
    
    //let element = document.getElementById('receivedOn');
    //element.setAttribute('min', maxDate);

    this.mindate = maxDate;
  }
}
